

























import betslip from '../../betCalculation/betslip'
import Requests from '@altenar/transport'
import callbacks from '@/config/callbacks'
import translations from '@/requests/staticTranslationsQuery'

export default {
  name: 'WBannerBetting',
  data() {
    return {
      reserveBet: new Requests.ReserveBet(),
      isReserveBetLoading: false
    }
  },
  created() {
    this.reserveBet.isLoading = loading => {
      this.isReserveBetLoading = loading
    }
    this.reserveBet.onSuccess = result => {
      callbacks.betreservation(result.ReservationKey)
      betslip.clearBetslip()
    }
  },
  computed: {
    selectedOddsIds() {
      return betslip.selectedOddsIds
    },
    placeBetText() {
      return translations.Buttons['Place bet']
    },
    enterBetStakeText() {
      return translations.Betslip['Stakes are empty']
    },
    inputValue() {
      return betslip.multipleStake
    },
    isPlaceBetEnable() {
      return betslip.multipleStake > 0
    }
  },
  methods: {
    onInputChange(event) {
      const value = event.currentTarget.value
      betslip.multipleStake = Number(value)
    },
    onInputDelayedChange(value) {
      // betslip.multipleStake = value
    },
    async onPlaceBetClick() {
      if (!this.isReserveBetLoading) {
        await this.reserveBet.fetchRequest({
          betslip: JSON.stringify(betslip.export())
        })
      }
    }
  }
}
